import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'

import apiConfig from '@services/apiConfig'

import { LIST_COLLECTIONS, setCollections } from '@actions/collection'
import errorHandler from '../errorHandler'

const classPrefix = '/collections'

function* listCollections({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/list-collections`,
      params,
    })
    yield put(setCollections(response.data))
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

export function* listCollectionsSaga() {
  yield takeLatest(LIST_COLLECTIONS, listCollections)
}
